/* eslint-disable no-loop-func */
import axios from "axios";
import "aws-sdk/dist/aws-sdk";
import _ from "lodash";
import { config } from "../configs";
import { getSessionToken } from "./getToken";

const createAsset = async (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets`;
      const { data } = await axios({
        method: "POST",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
        data: attributes,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getAssets = async (orgID = null) => {
  if (!orgID) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION");
    orgID = (org) ? JSON.parse(org)?.id : undefined;
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      let newData = data?.map((item) => ({ ...item, orgId: orgID }));
      if (data && data?.length) {
        resolve({ assets: newData });
      } else {
        resolve({ assets: [] });
      }
    } catch (error) {
      resolve({ asset: [] });
    }
  });
};

const getAssetsRelated = async (orgID = null) => {
  const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION");
  const currentOrgId = (org) ? JSON.parse(org)?.id : undefined;
  if (!orgID) {
    orgID = currentOrgId;
  }

  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets/related/${orgID}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: currentOrgId,
        },
        url: URL,
      });
      let newData = data?.map((item) => ({ ...item, orgId: orgID }));
      if (data && data?.length) {
        resolve({ assets: newData });
      } else {
        resolve({ assets: [] });
      }
    } catch (error) {
      resolve({ asset: [] });
    }
  });
};

// /customers/{customerId}/assets
const getCustomerAssets = async (orgId, customerID, placeId = null) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      let URL = `${config.baseURL}/assets/customer/${customerID}`;
      if (placeId && placeId !== "null" && placeId !== "overview") {
        URL += `?place=${placeId}`;
      }
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      resolve([]);
    }
  });
};

// Get the asset based on asset ID and organization.
const getAssetDetails = async (orgId, assetId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets/${assetId}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url: URL,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

// Patch request to update the asset detail.
const updateAssetDetails = async (orgId, assetId, attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/assets/${assetId}`;
      const response = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
        data: attributes,
      });
      resolve(response?.status);
    } catch (error) {
      reject(error);
    }
  });
};

const getAllAssets = async (workItemList, orgId, workEventId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const data = await Promise.all(
        workItemList.map(async (item) => {
          const asset = await getAssetDetails(orgId, item.asset?.system_id);
          const newDataMerged = Object.assign(
            { work_item: item["id"] },
            asset,
            { status: item["procedure_result_code"] }
          );
          return newDataMerged;
        })
      );

      let result = data.reduce(function (r, a) {
        if (a.place !== null) {
          r[a.place.name] = r[a.place.name] || [];
          r[a.place.name].push(a);
        } else {
          r["nonPlaces"] = r["nonPlaces"] || [];
          r["nonPlaces"].push(a);
        }

        return r;
      }, Object.create(null));

      return resolve({
        places: _.omit(result, ["nonPlaces"]) || [],
        nonPlaces: _.pick(result, ["nonPlaces"]) || [],
      });
    } catch (error) {
      reject(error);
    }
  });
};

const updateAssetImage = async (orgId, assetId, fileType) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/assets/${assetId}/imageurls/put`;
      const response = await axios.get(URL, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        params: {
          fileType,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  })
}

const putAssetImage = async (putUrl, file, filetype) => {
  return new Promise(async function (resolve, reject) {
    try {
      const response = await axios.put(putUrl, file, {
        headers: {
          "Content-Type": `image/${filetype}`,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

// {
//   "assigned_id": "cee5addf-76c5-4d9b-b1f0-4d200fc2bfdb",
//   "product_type": "Demo Type 1",
//   "make": "Demo Make 1",
//   "model": "Demo Model 1",
//   "serial_number": "NO-0001",
//   "custom_serial_number": "NO-S-0001",
//   "options": "string",
//   "description": "Test Description",
//   "location": "Test Location",
//   "disposition": "string",
//   "notes": "Test notes",
//   "attributes": [
//     {
//       "name": "string",
//       "value": "string"
//     }
//   ],
//   "asset_org_relations": [
//     {
//       "org": "TEST",
//       "org_to_asset_relationship": "OWNER"
//     }
//   ]
// }

export {
  createAsset,
  getAssets,
  getCustomerAssets,
  getAssetDetails,
  updateAssetDetails,
  getAllAssets,
  getAssetsRelated,
  updateAssetImage,
  putAssetImage
};
